import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const SEO = () => {

  // ✅ DEMO / CASE STUDY PROJECTS (STRATEGIC - INDUSTRY STYLE)
  const projects = [
    {
      title: "E-commerce SEO Growth",
      desc: "Increased organic traffic by 180% in 6 months through technical SEO and content optimization.",
      link: "#",
    },
    {
      title: "Local Business Ranking",
      desc: "Ranked a local business on Google’s first page for high-intent keywords.",
      link: "#",
    },
    {
      title: "SaaS SEO Strategy",
      desc: "Developed a full SEO strategy including keyword research, on-page SEO, and backlinking.",
      link: "#",
    },
    {
      title: "Website Technical Audit",
      desc: "Performed in-depth SEO audit fixing performance, indexing, and crawl issues.",
      link: "#",
    },
  ];

  // ✅ SEO TESTIMONIALS (STRATEGY FOCUSED)
  const testimonials = [
    {
      name: "Ahmed Raza",
      role: "Business Owner",
      feedback:
        "Our website traffic doubled within months. Their SEO strategy actually works.",
    },
    {
      name: "Fatima Noor",
      role: "E-commerce Manager",
      feedback:
        "We started ranking on Google and saw real business growth. Highly professional team.",
    },
    {
      name: "Hassan Ali",
      role: "Startup Founder",
      feedback:
        "They explained everything clearly and delivered measurable SEO results.",
    },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-green-600/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Rank Higher with <span className="text-green-400">SEO</span>
          </h1>

          <p className="mt-6 text-gray-300 text-lg max-w-2xl mx-auto">
            We help businesses grow organically by improving visibility,
            increasing traffic, and driving conversions.
          </p>

          <div className="mt-10 flex gap-4 justify-center flex-wrap">
            <Link to="/contact" className="px-8 py-4 bg-green-500 rounded-full hover:scale-105 transition">
              Get SEO Strategy
            </Link>

            <a
              href="https://calendly.com/thelogicwaves/30min"
              target="_blank"
              rel="noreferrer"
              className="px-8 py-4 border rounded-full hover:bg-white/10 transition"
            >
              Book a Call
            </a>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="py-24 px-6 max-w-5xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-8">SEO That Drives Results</h2>

        <p className="text-gray-300 leading-relaxed mb-6">
          SEO is not just about ranking — it’s about getting the right traffic
          that converts. We combine technical expertise, content strategy,
          and data-driven decisions to grow your business.
        </p>
      </section>

      {/* FEATURES */}
      <section className="py-24 px-6">
        <h2 className="text-4xl font-bold text-center mb-16">What We Do</h2>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {[
            { title: "Keyword Research", desc: "Find high-impact keywords your audience is searching for." },
            { title: "On-Page SEO", desc: "Optimize content, meta tags, and structure for ranking." },
            { title: "Technical SEO", desc: "Fix performance, indexing, and crawlability issues." },
            { title: "Content Strategy", desc: "Create SEO-driven content that ranks and converts." },
            { title: "Link Building", desc: "Build authority with high-quality backlinks." },
            { title: "Analytics & Reporting", desc: "Track performance and improve continuously." },
          ].map((item, i) => (
            <div key={i} className="bg-white/5 p-6 rounded-2xl border border-white/10 hover:scale-105 transition">
              <h3 className="text-xl font-semibold mb-3 text-green-400">
                {item.title}
              </h3>
              <p className="text-gray-400 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROCESS */}
      <section className="py-24 px-6 bg-[#0b1a35] text-center">
        <h2 className="text-4xl font-bold mb-16">Our SEO Process</h2>

        <div className="grid md:grid-cols-4 gap-10 max-w-6xl mx-auto">
          {["Audit", "Strategy", "Optimize", "Grow"].map((step, i) => (
            <div key={i}>
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-green-500 text-xl font-bold">
                {i + 1}
              </div>
              <p className="text-gray-300">{step}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROJECTS (DEMO CASE STUDIES) */}
      <ProjectsSection projects={projects} />

      {/* TESTIMONIALS */}
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-green-500 to-teal-500 px-6">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Grow Your Business Organically
        </h2>

        <p className="text-gray-200 mb-8">
          Let’s take your website to the top of search results.
        </p>

        <Link to="/contact" className="bg-black px-6 py-3 rounded-full hover:scale-105 transition">
          Contact Us
        </Link>
      </section>

    </div>
  );
};

export default SEO;